import { Component, OnInit } from '@angular/core';
import { SaleService } from '../../services/sale.service';
import { UserService } from '../../../common/services/user.service';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';

import { Observable } from 'rxjs/Observable';
declare let alasql;

@Component({
  selector: 'app-list-tickets',
  templateUrl: './list-tickets.component.html',
  styleUrls: ['./list-tickets.component.css'],
  providers:[ SaleService,UserService]
})
export class ListTicketsComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  tickets: any = [];
  users: any = [];
  filters:any = {
    type:{contains: ""},
    number_with_serie:{contains: ""},
    method_of_payment:{contains: ""},
  };
  fromDate:any;
  untilDate:any;
  exportParams:any ={};
  showExportButton:boolean = true;
  role:number = 3;

  constructor( private saleService:SaleService, private userService:UserService) { }

  ngOnInit() {
    this.getUsers().then(()=>{
       this.getTickets();
    });
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getUsers(){
    return new Promise((resolve, reject) => {
        this.userService.query({})
            .subscribe((users) => {
                this.users = users;
                this.users.unshift({id:null, username:"Ninguno"})
                resolve();
            });
    });
  }

  getUser(id){
      let result = this.users.filter( (e)=>{
        return e.id === id;
      });
      return result[0]?result[0].username:"";
  }
  
  getTickets(){
    if (this.filters.createdBy == null){
        delete this.filters.createdBy;
    }
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'date DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    this.exportParams = params;
    this.saleService.queryGeneralTickets(params)
      .subscribe((tickets) => {
          this.tickets = tickets;
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.saleService.countGeneralTickets(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
      });
  }

  exportTicketsToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };    
    let report = [
            {
                field1:"Tipo",
                field2:"Nº con serie",
                field3:"Fecha",
                field4:"Total",
                field5:"Método de pago",
                field6:"Usuario"
                
            }
    ]
    delete this.exportParams.skip;
    delete this.exportParams.limit;
    let observableTicketsRequest = [];
    let request = Math.ceil(this.totalItems / 100);
    for (let i=0; i<request;i++){
      this.exportParams.skip = ((i)*100),
      this.exportParams.limit = 100;
      observableTicketsRequest.push(this.saleService.queryGeneralTickets(this.exportParams));
    }
    Observable.forkJoin(observableTicketsRequest)
        .subscribe(data => {
          let p:any = data;
          let tickets = p.flat(); 

          tickets.forEach(ticket =>{
                var row = {
                    field1:ticket.type?ticket.type:"",
                    field2:ticket.number_with_serie?ticket.number_with_serie:"",
                    field3:ticket.date?moment(ticket.date).format("DD-MM-YYYY"):"",
                    field4:ticket.total?ticket.total:"",
                    field5:ticket.method_of_payment?ticket.method_of_payment:"",
                    field6:this.getUser(ticket.createdBy)
                }
                report.push(row);
              });
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:100,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE TICKETS'},
                      {columnid:'field4',width:100,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:100,title: ''},
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                              5:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  },
                      }   
                },
          };
          this.showExportButton = true;
          alasql.promise('SELECT * INTO XLSXML("Tickets_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
      });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/sales/components/list-tickets/list-tickets.component.ts